module.exports = __webpack_public_path__ + "static/img/kOnzy.9e0373c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/gif/kOnzy.gif
// module id = ZEr+
// module chunks = 1